import axios from 'axios';

/**
 * Запрос отменили (уход со страницы, новый поиск, `AbortController`), а не отказал сервер: такой отказ не показывают.
 * Отмена axios (`CanceledError`), `AbortError` fetch или уже прерванный `signal` вызывающего.
 */
export const isRequestCanceled = (error: unknown, signal?: AbortSignal): boolean => {
    if (signal?.aborted) {
        return true;
    }

    if (axios.isCancel(error)) {
        return true;
    }

    return error instanceof Error && (error.name === 'CanceledError' || error.name === 'AbortError');
};
